import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useQuoteImportStatusReducer = () => useSelector((state: ApplicationState) => state.quoteImportStatus);
